(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slideshow-zunny"] && !Shopify.designMode) return;
  try {
    
  class VideoSlideshow {
    constructor(container) {
      this.container = container;
      this.slidesContainer = container.querySelector('.video-slides-container');
      this.slides = container.querySelectorAll('.video-slide');
      this.dots = container.querySelectorAll('.video-pagination-dot');
      this.prevBtn = container.querySelector('[data-nav="prev"]');
      this.nextBtn = container.querySelector('[data-nav="next"]');
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;

      if (this.totalSlides <= 1) return;

      this.init();
    }

    init() {
      // Navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.goToSlide(this.currentIndex - 1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.goToSlide(this.currentIndex + 1));
      }

      // Pagination dots
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Keyboard navigation
      this.container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.goToSlide(this.currentIndex - 1);
        if (e.key === 'ArrowRight') this.goToSlide(this.currentIndex + 1);
      });

      // Update on scroll (for swipe/scroll gestures)
      let scrollTimeout;
      this.slidesContainer.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => this.updateCurrentSlide(), 100);
      });

      // Pause videos when changing slides
      this.slidesContainer.addEventListener('scroll', () => {
        this.pauseAllVideos();
      });
    }

    goToSlide(index) {
      // Loop logic
      if (index < 0) index = this.totalSlides - 1;
      if (index >= this.totalSlides) index = 0;

      this.currentIndex = index;

      // Scroll to slide
      const slideWidth = this.slides[0].offsetWidth;
      this.slidesContainer.scrollLeft = slideWidth * index;

      this.updateUI();
      this.pauseAllVideos();
    }

    updateCurrentSlide() {
      const slideWidth = this.slides[0].offsetWidth;
      const scrollLeft = this.slidesContainer.scrollLeft;
      const newIndex = Math.round(scrollLeft / slideWidth);

      if (newIndex !== this.currentIndex) {
        this.currentIndex = newIndex;
        this.updateUI();
      }
    }

    updateUI() {
      // Update dots
      this.dots.forEach((dot, index) => {
        if (index === this.currentIndex) {
          dot.classList.add('active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove('active');
          dot.setAttribute('aria-selected', 'false');
        }
      });
    }

    pauseAllVideos() {
      const iframes = this.container.querySelectorAll('[data-video-iframe]');
      iframes.forEach(iframe => {
        // For YouTube videos with enablejsapi=1
        if (iframe.src.includes('youtube.com')) {
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
        // For Vimeo videos
        if (iframe.src.includes('vimeo.com')) {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshows);
  } else {
    initSlideshows();
  }

  function initSlideshows() {
    const containers = document.querySelectorAll('.video-slideshow-zunny-wrapper');
    containers.forEach(container => new VideoSlideshow(container));
  }

  } catch(e) { console.error(e); }
})();
})();
